export enum OnboardingTabs {
  general = "General",
  documents = "Documents",
  contacts = "Contacts",
  purchasingInfo = "PurchasingInfo",
  locations = "Locations",
  supplierTerms = "Supplier Terms",
}
